'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { reportAdminError } from '@/lib/admin/reportAdminError';
export default function AdminError(t0) {
  const $ = _c(13);
  const {
    error,
    reset
  } = t0;
  const pathname = usePathname();
  const [reference, setReference] = useState(null);
  let t1;
  let t2;
  if ($[0] !== error || $[1] !== pathname) {
    t1 = () => {
      let cancelled = false;
      reportAdminError(error, pathname).then(eventId => {
        if (!cancelled) {
          setReference(eventId);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [error, pathname];
    $[0] = error;
    $[1] = pathname;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="text-xl font-semibold">Something went wrong</h2>;
    t4 = <p className="text-muted-foreground max-w-md">An unexpected error occurred. Your data has not been affected.</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== reference) {
    t5 = reference && <p className="text-xs text-muted-foreground" data-testid="admin-error-reference">Reference: <span className="font-mono">{reference}</span></p>;
    $[6] = reference;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== reset) {
    t6 = <Button onClick={reset}>Try again</Button>;
    $[8] = reset;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="flex flex-col items-center justify-center min-h-[400px] gap-4 p-8 text-center">{t3}{t4}{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}